export enum ActivityStreamEntityType {
  EvaluationMember,
  IndividualMultiplier,
  Merit,
  SpecialPayment,
  OrgPlanningOrganisation,
  OrgPlanningPosition,
  OrgPlanningEmployee,
  Season,
  Record,
  SuccessionManagementTalentPool,
  ClauseVersion,
  TemplateVersion,
  EclTemplates,
  EclClauses,
  PositionRequest,
  MercerMasterData,
  StandingPositionEvaluation,
  OrgManagementOrganisation,
  ExceptionalRecognitions,
  Authorization,
  AuthorizationUser
}
